module.exports = {"apiURL":"https://live-vr-editor.pantheonsite.io","clientId":"16b0ed87-7116-40d2-9b26-354af3b2deb3"}


//////////////////
// WEBPACK FOOTER
// ./src/config/production.json
// module id = 2331
// module chunks = 0